// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: admin/payload/AdminDashboardPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { EntryStatusPayload, entryStatusPayloadFromJSON, entryStatusPayloadToJSON } from "../../entry/model/EntryPt";
import {
  FightSportPayload,
  fightSportPayloadFromJSON,
  fightSportPayloadToJSON,
} from "../../fight/model/enums/FightSportPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.admin.payload";

/** 집계 종류 */
export enum AdminDashboardStatKeyPayload {
  ADMIN_DASHBOARD_STAT_UNKNOWN = 0,
  /** ADMIN_DASHBOARD_STAT_ENTRY_COUNT - 신청 건수 (체육관 단위) */
  ADMIN_DASHBOARD_STAT_ENTRY_COUNT = 1,
  /** ADMIN_DASHBOARD_STAT_PLAYER_COUNT - 신청 선수 수 */
  ADMIN_DASHBOARD_STAT_PLAYER_COUNT = 2,
  /** ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT - 승인 대기 선수 수 */
  ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT = 3,
  /** ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT - 접수 중 대회 수 */
  ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT = 4,
  UNRECOGNIZED = -1,
}

export function adminDashboardStatKeyPayloadFromJSON(object: any): AdminDashboardStatKeyPayload {
  switch (object) {
    case 0:
    case "ADMIN_DASHBOARD_STAT_UNKNOWN":
      return AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_UNKNOWN;
    case 1:
    case "ADMIN_DASHBOARD_STAT_ENTRY_COUNT":
      return AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_ENTRY_COUNT;
    case 2:
    case "ADMIN_DASHBOARD_STAT_PLAYER_COUNT":
      return AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_PLAYER_COUNT;
    case 3:
    case "ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT":
      return AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT;
    case 4:
    case "ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT":
      return AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdminDashboardStatKeyPayload.UNRECOGNIZED;
  }
}

export function adminDashboardStatKeyPayloadToJSON(object: AdminDashboardStatKeyPayload): string {
  switch (object) {
    case AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_UNKNOWN:
      return "ADMIN_DASHBOARD_STAT_UNKNOWN";
    case AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_ENTRY_COUNT:
      return "ADMIN_DASHBOARD_STAT_ENTRY_COUNT";
    case AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_PLAYER_COUNT:
      return "ADMIN_DASHBOARD_STAT_PLAYER_COUNT";
    case AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT:
      return "ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT";
    case AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT:
      return "ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT";
    case AdminDashboardStatKeyPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * 대시보드 집계 요청
 *
 * tournamentId 를 비우면 「접수 중 · 진행 중」 대회를 모두 합산한다.
 */
export interface AdminDashboardGetSummaryRequestPayload {
  /** 집계 대상 대회 id (선택) */
  tournamentId: string;
}

export interface AdminDashboardGetSummaryResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 로그인한 관리자명 */
  managerName: string;
  /** 집계 카드 */
  stat: AdminDashboardStatPayload[];
  /** 최근 접수된 신청 */
  recentEntry: AdminDashboardRecentEntryPayload[];
}

/**
 * 집계 카드 한 칸
 *
 * 아이콘 · 색상은 화면이 key 로 정한다 — 서버는 표시 스타일을 내려보내지 않는다.
 */
export interface AdminDashboardStatPayload {
  /** 집계 종류 */
  key: AdminDashboardStatKeyPayload;
  /** 집계 값 */
  value: number;
  /** 보조 설명에 쓰는 값 (예: 승인 대기 중 오늘 접수분) */
  subValue: number;
}

/** 최근 접수된 신청 한 줄 */
export interface AdminDashboardRecentEntryPayload {
  /** 신청번호 */
  entryNo: string;
  /** 체육관명 */
  gymName: string;
  /** 대표 선수명 (신청의 첫 선수) */
  playerName: string;
  /** 신청 선수 수 */
  playerCount: number;
  /** 대표 종목 */
  sport: FightSportPayload;
  /** 접수 일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  appliedAt: string;
  /** 신청 상태 */
  status: EntryStatusPayload;
}

function createBaseAdminDashboardGetSummaryRequestPayload(): AdminDashboardGetSummaryRequestPayload {
  return { tournamentId: "" };
}

export const AdminDashboardGetSummaryRequestPayload: MessageFns<AdminDashboardGetSummaryRequestPayload> = {
  encode(message: AdminDashboardGetSummaryRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminDashboardGetSummaryRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminDashboardGetSummaryRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminDashboardGetSummaryRequestPayload {
    return { tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "" };
  },

  toJSON(message: AdminDashboardGetSummaryRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminDashboardGetSummaryRequestPayload>, I>>(
    base?: I,
  ): AdminDashboardGetSummaryRequestPayload {
    return AdminDashboardGetSummaryRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminDashboardGetSummaryRequestPayload>, I>>(
    object: I,
  ): AdminDashboardGetSummaryRequestPayload {
    const message = createBaseAdminDashboardGetSummaryRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseAdminDashboardGetSummaryResponsePayload(): AdminDashboardGetSummaryResponsePayload {
  return { result: undefined, managerName: "", stat: [], recentEntry: [] };
}

export const AdminDashboardGetSummaryResponsePayload: MessageFns<AdminDashboardGetSummaryResponsePayload> = {
  encode(message: AdminDashboardGetSummaryResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.managerName !== "") {
      writer.uint32(18).string(message.managerName);
    }
    for (const v of message.stat) {
      AdminDashboardStatPayload.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.recentEntry) {
      AdminDashboardRecentEntryPayload.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminDashboardGetSummaryResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminDashboardGetSummaryResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.managerName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stat.push(AdminDashboardStatPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.recentEntry.push(AdminDashboardRecentEntryPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminDashboardGetSummaryResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      managerName: isSet(object.managerName) ? globalThis.String(object.managerName) : "",
      stat: globalThis.Array.isArray(object?.stat)
        ? object.stat.map((e: any) => AdminDashboardStatPayload.fromJSON(e))
        : [],
      recentEntry: globalThis.Array.isArray(object?.recentEntry)
        ? object.recentEntry.map((e: any) => AdminDashboardRecentEntryPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AdminDashboardGetSummaryResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.managerName !== "") {
      obj.managerName = message.managerName;
    }
    if (message.stat?.length) {
      obj.stat = message.stat.map((e) => AdminDashboardStatPayload.toJSON(e));
    }
    if (message.recentEntry?.length) {
      obj.recentEntry = message.recentEntry.map((e) => AdminDashboardRecentEntryPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminDashboardGetSummaryResponsePayload>, I>>(
    base?: I,
  ): AdminDashboardGetSummaryResponsePayload {
    return AdminDashboardGetSummaryResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminDashboardGetSummaryResponsePayload>, I>>(
    object: I,
  ): AdminDashboardGetSummaryResponsePayload {
    const message = createBaseAdminDashboardGetSummaryResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.managerName = object.managerName ?? "";
    message.stat = object.stat?.map((e) => AdminDashboardStatPayload.fromPartial(e)) || [];
    message.recentEntry = object.recentEntry?.map((e) => AdminDashboardRecentEntryPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminDashboardStatPayload(): AdminDashboardStatPayload {
  return { key: 0, value: 0, subValue: 0 };
}

export const AdminDashboardStatPayload: MessageFns<AdminDashboardStatPayload> = {
  encode(message: AdminDashboardStatPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    if (message.subValue !== 0) {
      writer.uint32(24).int32(message.subValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminDashboardStatPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminDashboardStatPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.subValue = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminDashboardStatPayload {
    return {
      key: isSet(object.key) ? adminDashboardStatKeyPayloadFromJSON(object.key) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      subValue: isSet(object.subValue) ? globalThis.Number(object.subValue) : 0,
    };
  },

  toJSON(message: AdminDashboardStatPayload): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = adminDashboardStatKeyPayloadToJSON(message.key);
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    if (message.subValue !== 0) {
      obj.subValue = Math.round(message.subValue);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminDashboardStatPayload>, I>>(base?: I): AdminDashboardStatPayload {
    return AdminDashboardStatPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminDashboardStatPayload>, I>>(object: I): AdminDashboardStatPayload {
    const message = createBaseAdminDashboardStatPayload();
    message.key = object.key ?? 0;
    message.value = object.value ?? 0;
    message.subValue = object.subValue ?? 0;
    return message;
  },
};

function createBaseAdminDashboardRecentEntryPayload(): AdminDashboardRecentEntryPayload {
  return { entryNo: "", gymName: "", playerName: "", playerCount: 0, sport: 0, appliedAt: "", status: 0 };
}

export const AdminDashboardRecentEntryPayload: MessageFns<AdminDashboardRecentEntryPayload> = {
  encode(message: AdminDashboardRecentEntryPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entryNo !== "") {
      writer.uint32(10).string(message.entryNo);
    }
    if (message.gymName !== "") {
      writer.uint32(18).string(message.gymName);
    }
    if (message.playerName !== "") {
      writer.uint32(26).string(message.playerName);
    }
    if (message.playerCount !== 0) {
      writer.uint32(32).int32(message.playerCount);
    }
    if (message.sport !== 0) {
      writer.uint32(40).int32(message.sport);
    }
    if (message.appliedAt !== "") {
      writer.uint32(50).string(message.appliedAt);
    }
    if (message.status !== 0) {
      writer.uint32(56).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminDashboardRecentEntryPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminDashboardRecentEntryPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gymName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.playerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.playerCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.appliedAt = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminDashboardRecentEntryPayload {
    return {
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      gymName: isSet(object.gymName) ? globalThis.String(object.gymName) : "",
      playerName: isSet(object.playerName) ? globalThis.String(object.playerName) : "",
      playerCount: isSet(object.playerCount) ? globalThis.Number(object.playerCount) : 0,
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      appliedAt: isSet(object.appliedAt) ? globalThis.String(object.appliedAt) : "",
      status: isSet(object.status) ? entryStatusPayloadFromJSON(object.status) : 0,
    };
  },

  toJSON(message: AdminDashboardRecentEntryPayload): unknown {
    const obj: any = {};
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.gymName !== "") {
      obj.gymName = message.gymName;
    }
    if (message.playerName !== "") {
      obj.playerName = message.playerName;
    }
    if (message.playerCount !== 0) {
      obj.playerCount = Math.round(message.playerCount);
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.appliedAt !== "") {
      obj.appliedAt = message.appliedAt;
    }
    if (message.status !== 0) {
      obj.status = entryStatusPayloadToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminDashboardRecentEntryPayload>, I>>(
    base?: I,
  ): AdminDashboardRecentEntryPayload {
    return AdminDashboardRecentEntryPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminDashboardRecentEntryPayload>, I>>(
    object: I,
  ): AdminDashboardRecentEntryPayload {
    const message = createBaseAdminDashboardRecentEntryPayload();
    message.entryNo = object.entryNo ?? "";
    message.gymName = object.gymName ?? "";
    message.playerName = object.playerName ?? "";
    message.playerCount = object.playerCount ?? 0;
    message.sport = object.sport ?? 0;
    message.appliedAt = object.appliedAt ?? "";
    message.status = object.status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
